import React, { useEffect, useRef, useState } from 'react'
import BootstrapTable from 'react-bootstrap-table-next';
import Breadcrumbs from '../components/Breadcrumbs';
import TopFilter from '../components/TopFilter';
import RightFilterToggle from '../components/RightFilterToggle';
import paginationFactory from 'react-bootstrap-table2-paginator';
import GridData from '../components/gridmodal/GridDataPackages';
// import { propTypes } from 'react-bootstrap/esm/Image';
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import filterFactory, { textFilter, customFilter } from 'react-bootstrap-table2-filter';
import PropTypes from 'prop-types';
import 'bootstrap/dist/css/bootstrap.css';
import ToolkitProvider, { CSVExport } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min';
import 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css';
// import PriceFilter from '../components/CustomGridFilter';
import configData from '../configData.json';
import { format } from 'date-fns';
import Spinner from 'react-bootstrap/Spinner';
import ColumnFilter from '../components/ColumnFilter';
import { Link } from 'react-router-dom';
import TopBar from '../components/TopBar';
import Footer from '../components/Footer';
import LeftMenu from '../components/LeftMenu';
import ForecastRightFilterToggle from '../components/ForecastRightFilterToggle';
import MycustomDesignGrid from '../components/MycustomDesignGrid';
import { ValidDate, formatNumnberWithComma, formatAmountWithComma, formatDate, removeCommafromNumber, toLocalDate } from '../components/Utlities';

export default function TopBillsByCharacters() {

    const [ProcessedBills, setProcessedBills] = useState([]);
    const [DetailByCustCarr, setDetailData] = useState([]);
    const [selectedSummaryRow, setSelectedRow] = useState({});
    const [lastElement, setLastElement] = useState(null);
    const [hidden, setHidden] = useState(true);
    const [fbNum, setFbNum] = useState("");
    const [acctNo, setAcctNo] = useState("");

    const [custKey, setCustomerKey] = useState(0);
    const [carrKey, setCarrierKey] = useState(0);

    const { ExportCSVButton } = CSVExport;
    const { ExportCSVButtonDetail } = CSVExport;

    const [fromDate, setFromDate] = useState(undefined);
    const [toDate, setToDate] = useState(undefined);
    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(1);
    const [fbLoading, setFBLoading] = useState(false);
    const [prevY, setPrevY] = useState(0);

    let prevYRef = useRef({});
    let selectedRowRef = useRef({});
    let DetailByCustCarrRef = useRef({});
    let hiddenRef = useRef({});
    let pageRef = useRef({});

    prevYRef.current = prevY;
    selectedRowRef.current = selectedSummaryRow;
    DetailByCustCarrRef.current = DetailByCustCarr;
    hiddenRef.current = hidden;
    pageRef.current = page;

    const criData = [
        { criKey: 1, criValue: 'Owner' },
        { criKey: 2, criValue: 'Customer' },
        { criKey: 3, criValue: 'Transportation Provider' },
        // { criKey: 4, criValue: 'Freight Bill Number' },
        { criKey: 5, criValue: 'Transportation Provider Account Number' }
    ];


    const searchOnClick = (customerKey, carrierKey, startDate, endDate, freightBillNumber, accountNumber) => {

        const topBills = document.getElementById("topbills").value;
        console.log(topBills);
        const fbNumber = freightBillNumber === "" ? "-1" : freightBillNumber;
        const acctNumber = accountNumber === "" ? "-1" : accountNumber;

        setCustomerKey(customerKey);
        setCarrierKey(carrierKey);
        setFromDate(startDate);
        setToDate(endDate);
        setFbNum(freightBillNumber);
        setAcctNo(accountNumber);
        LoadSummaryData(customerKey, carrierKey, startDate, endDate, fbNumber, acctNumber, topBills);
    }

    const LoadSummaryData = async (customerKey, carrierKey, startDate, endDate, fbNumber, accountNumber, topBills) => {
        // debugger;
        setLoading(true);
        setProcessedBills([]);
        const URL = `${configData.BASE_APP_URL}FreightBill/GetTopBillsByCharacter/${customerKey}/${carrierKey}/${startDate}/${endDate}/${fbNumber}/${topBills}/${accountNumber}`;
        console.log(URL);

        try {
            const response = await fetch(URL, {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            });

            if (response.ok) {
                const data = await response.json();

                // Convert 'characterCount', 'pageCount', 'captureCount', and 'populateCount' to formatted strings in the response
                const modifiedResponse = data.map(item => ({
                    ...item,
                    characterCount: formatNumnberWithComma(item.characterCount),
                    pageCount: formatNumnberWithComma(item.pageCount),
                    captureCount: formatNumnberWithComma(item.captureCount),
                    populateCount: formatNumnberWithComma(item.populateCount),
                    // Add more properties as needed
                }));

                setProcessedBills(modifiedResponse);
            } else {
                console.error(`Error fetching data: ${response.statusText}`);
            }
        } catch (error) {
            console.error('Error during fetch:', error);
        } finally {
            setLoading(false);
        }
    };


    const onTopBillsSelect = (e) => {
        // debugger;
        // onchange="this.nextElementSibling.value=this.value"
        const topBills = document.getElementById("topbills").value;
        const fbNumber = fbNum === "" ? "-1" : fbNum;
        const acctNumber = acctNo === "" ? "-1" : acctNo;
        LoadSummaryData(custKey, carrKey, fromDate, toDate, fbNumber, acctNumber, topBills);
    };

    const LoadDetailData = async (customerKey, carrierKey, billType, setLoadingFunc, fromDetails) => {
        setLoadingFunc(true);
        const fbNumber = fbNum === "" ? "-1" : fbNum;
        const acctNumber = acctNo === "" ? "-1" : acctNo;

        const URL = `${configData.BASE_APP_URL}FreightBill/GetProcessedInvoiceDetailByPage/${customerKey}/${carrierKey}/${billType}/${fromDate}/${toDate}/${pageRef.current}/${fbNumber}/${acctNumber}/${configData.PAGE_SIZE}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => {
                setDetailData([...DetailByCustCarrRef.current, ...resp]);
                //OpenPopup();
                setHidden(false);
            })
        setLoadingFunc(false);
    }

    const columnFormatter = (cell, row, rowIndex, formatExtraData) => {
        return (
            <div>
                <span><a href='#'><i className="fa fa-expand mr-1"></i></a>{row.customerName}</span>
            </div>
        )
    }


    const freightBillFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        return (
            "=" + '"' + cell + '"'
        )
    }

    const invoicenumberFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        return (
            "=" + '"' + cell + '"'
        )
    }
    const accountnumberFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        return (
            "=" + '"' + cell + '"'
        )
    }


    const invoiceDateFormatter = (cell, row, rowIndex, formatExtraData) => {
        if (cell === "" || cell === null) {
            return <span></span>;
        }
        else {
            return (
                <span>{format(toLocalDate(cell), "MM/dd/yyyy")}</span>
            );
        }
    }

    const invoiceDateFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        let newDate = format(new Date(cell), "MM/dd/yyyy");
        return (
            "=SUBSTITUTE(" + '"' + newDate + '"' + "," + '"' + "-" + '"' + "," + '"' + "/" + '"' + ")"
        )
    }

    const imageLinkFormatter = (cell, row, rowIndex, formatExtraData) => {
        return (
            <a target="_blank" href={cell}>View</a>
        )
    }

    const imageLinkFormattercsv = (cell, row, rowIndex, formatExtraData) => {
        return (
            "=HYPERLINK(" + '"' + cell + '",' + '"' + "View" + '"' + ")"
        )
    }




    const OpenPopup = () => {
        setHidden(false);
        if (hiddenRef.current) {
            // setPage(1);
            // setDetailData([]);
            //setSelectedRow({})
        }
    }

    const columnsDetail = [
        {
            dataField: 'freightBillNumber',
            text: 'Freight Bill Number',
            headerStyle: { width: '140px', textAlign: 'center' },
            align: 'left',
            csvFormatter: freightBillFormattercsv

        },
        {
            dataField: 'invoiceNumber',
            text: 'Invoice Number',
            headerStyle: { width: '120px', textAlign: 'center' },
            align: 'left'
        },
        {
            dataField: 'accountNumber',
            text: 'Account Number',
            headerStyle: { width: '85px', textAlign: 'center' },
            align: 'left'
        },
        {
            dataField: 'invoiceDate',
            text: 'Invoice Date',
            headerStyle: { width: '80px', textAlign: 'center' },
            align: 'left',
            formatter: invoiceDateFormatter,
            csvFormatter: invoiceDateFormattercsv
        },
        {
            dataField: 'billType',
            text: 'Bill Type',
            headerStyle: { width: '110px', textAlign: 'center' },
            align: 'center'
        },
        {
            dataField: 'characterCount',
            text: 'Number of Characters',
            headerStyle: { width: '92px', textAlign: 'center' },
            align: 'right'
        },
        {
            dataField: 'pageCount',
            text: 'Number of Pages',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'right'
        },
        {
            dataField: 'captureCount',
            text: 'Data Fields Captured',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'right'
        },
        {
            dataField: 'populateCount',
            text: 'Data Elements Populated',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'right'
        },
        {
            dataField: 'manualBill',
            text: 'Manual Bill',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'center'
        },
        {
            dataField: 'imageLink',
            text: 'Image Link',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'center',
            formatter: imageLinkFormatter,
            csvFormatter: imageLinkFormattercsv
        }
    ]

    let onCustomerFilter;
    let onCarrierFilter;
    const onCustomerChangeFilter = (selectedCust, selectedCarrier, selectedFromDate, selectedToDate, fbNum, acctNo) => {
        //debugger;
        // onCustomerFilter(val);
        // debugger;
        const topBills = document.getElementById("topbills").value;


        setCustomerKey(selectedCust);
        setCarrierKey(selectedCarrier);
        setFromDate(selectedFromDate);
        setToDate(selectedToDate);
        setFbNum(fbNum);
        setAcctNo(acctNo);
        LoadSummaryData(selectedCust, selectedCarrier, selectedFromDate, selectedToDate, fbNum, acctNo, topBills);
    };
    const onCarrierChangeFilter = (val) => {
        //onCarrierFilter(val);
        console.log(val)
    };

    const columns = [
        {
            dataField: 'customerName',
            text: 'Customer',
            headerStyle: { width: '157px', textAlign: 'center' },
            filter: customFilter(),
            filterRenderer: (onFilter, column) => {
                onCustomerFilter = onFilter;
                <ColumnFilter onFilter={onFilter} column={column} />
            }
        },
        {
            dataField: 'carrierName',
            text: 'Transportation Provider',
            headerStyle: { width: '285px', textAlign: 'center' },
            sort: true,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'freightBillNumber',
            text: 'Freight Bill/Package Number',
            headerStyle: { width: '180px', textAlign: 'center' },
            csvFormatter: freightBillFormattercsv,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'invoiceNumber',
            text: 'Invoice Number',
            headerStyle: { width: '180px', textAlign: 'center' },
            csvFormatter: invoicenumberFormattercsv,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'invoiceDate',
            text: 'Invoice Date',
            headerStyle: { width: '80px', textAlign: 'center' },
            sort: true,
            align: 'left',
            formatter: invoiceDateFormatter,
            csvFormatter: invoiceDateFormattercsv

        },
        {
            dataField: 'accountCode',
            text: 'Account Number',
            headerStyle: { width: '97px', textAlign: 'center' },
            sort: true,
            csvFormatter: accountnumberFormattercsv
        },
        {
            dataField: 'billType',
            text: 'Bill Type',
            headerStyle: { width: '110px', textAlign: 'center' },
            sort: true,
            filter: customFilter(),
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />

        },
        {
            dataField: 'characterCount',
            text: 'Total Number of Characters',
            headerStyle: { width: '100px', textAlign: 'center' },
            sort: true,
            align: 'right',
        },
        {
            dataField: 'pageCount',
            text: 'Total Number of Pages',
            headerStyle: { width: '110px', textAlign: 'center' },
            sort: true,
            align: 'right',
        },
        {
            dataField: 'captureCount',
            text: 'Total Number of Data Fields Captured',
            headerStyle: { width: '130px', textAlign: 'center' },
            sort: true,
            align: 'right',
        },
        {
            dataField: 'populateCount',
            text: 'Total Number of Data Fields Populated',
            headerStyle: { width: '130px', textAlign: 'center' },
            align: 'right',
            sort: true,
        },
        {
            dataField: 'manualBill',
            text: 'Manual Bill',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'center',
            sort: true
        },
        {
            dataField: 'freightBillKey',
            text: 'Freight Bill Key',
            headerStyle: { width: '150px', textAlign: 'center' },
            align: 'left',
            filter: customFilter(),
            sort: true,
            filterRenderer: (onFilter, column) =>
                <ColumnFilter onFilter={onFilter} column={column} />
        },
        {
            dataField: 'imageLink',
            text: 'Image Link',
            headerStyle: { width: '97px', textAlign: 'center' },
            align: 'center',
            formatter: imageLinkFormatter,
            csvFormatter: imageLinkFormattercsv

        }
    ];

    const pagingOptioins = {
        root: null,
        rootMargin: "0px",
        threshold: 1.0
    }

    const observer = useRef(
        new IntersectionObserver((entries, pagingOptioins) => {
            const first = entries[0];
            if (first.isIntersecting) {
                setPage((no) => no + 1);
            }
        })
    );

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    useEffect(() => {
        if (selectedSummaryRow.customerKey) {
            LoadDetailData(selectedSummaryRow.customerKey, selectedSummaryRow.carrierKey, selectedSummaryRow.billType, setFBLoading, true)
        }
    }, [pageRef.current])

    useEffect(() => {
        const currentElement = lastElement;
        const currentObserver = observer.current;

        if (currentElement) {
            currentObserver.observe(currentElement);
        }

        return () => {
            if (currentElement) {
                currentObserver.unobserve(currentElement);
            }
        };
    }, [lastElement]);

    const sizePerPageRenderer = ({
        options,
        currSizePerPage,
        onSizePerPageChange
    }) => (
        <div className="btn-group" role="group">
            {
                options.map((option) => {
                    const isSelect = currSizePerPage === `${option.page}`;
                    return (
                        <button
                            key={option.text}
                            type="button"
                            onClick={() => onSizePerPageChange(option.page)}
                            className={`btn ${isSelect ? 'btn-secondary' : 'btn-warning'}`}
                        >
                            {option.text}
                        </button>
                    );
                })
            }
        </div>
    );

    const options = {
        sizePerPageRenderer,
        sizePerPageList: [{
            text: '50', value: 50
        }, {
            text: '100', value: 100
        },
        {
            text: '200', value: 200
        }, {
            text: 'All', value: ProcessedBills.length + 1
        }]
    };

    const DownloadSummaryData = async () => {
        debugger;
        const URL = `${configData.BASE_APP_URL}FreightBill/GenerateExcelInvoiceProcessedByCharacter`;
        // console.log(URL);

        const modifiedResponse = ProcessedBills.map(item => ({
            ...item,
            characterCount: removeCommafromNumber(item.characterCount),
            pageCount: removeCommafromNumber(item.pageCount),
            captureCount: removeCommafromNumber(item.captureCount),
            populateCount: removeCommafromNumber(item.populateCount),
            // Add more properties as needed
        }));


        const response = await fetch(URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('my-token')
            },
            body: JSON.stringify({ data: modifiedResponse }),
            responseType: 'blob'
        });

        const data = await response.blob();
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(data);
        link.download = `Invoices Processed By Characters.xlsx`;
        link.click();

    };

    const breadcumTitle = <div dangerouslySetInnerHTML={{ __html: 'Invoices Processed By Characters <span class="breadcumspan">(Top bills with greatest number of Characters by Customer/Provider )</span>' }} />;

    return (
        <>
            <div className='st1'>
                <LeftMenu />
                <div className="mcw">
                    <TopBar />
                    <div className='pt-1 px-3 pb-3 py-3'>

                        {/* <Breadcrumbs title="Invoices Processed By Character ( Top 10 Bills By Greatest Number of Character)" /> */}
                        <Breadcrumbs title={breadcumTitle} />
                        {loading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : loading}
                        <div className='sticky-top-content'>
                            <TopFilter oncustom={onCustomerChangeFilter} oncustom1={onCarrierChangeFilter} criData={criData} />
                        </div>
                        <div className='row mb-1'>
                            <div className='col-1 pe-0'>Top Bills</div>
                            <div className='col-2 topbills'>
                                <select id="topbills" onChange={onTopBillsSelect}>
                                    <option value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                    <option value="200">200</option>
                                </select>
                            </div>
                        </div>

                        <div className='d-flex'>

                            <div className="table-container">
                                <div className='grid-toggle'>
                                    <div className='main-table-text dropup'>
                                        {ProcessedBills.length > 0 ?
                                            <ToolkitProvider
                                                keyField="freightBillKey"
                                                data={ProcessedBills}
                                                columns={columns}
                                                exportCSV={{ fileName: 'Invoices Processed By Character.csv' }}>
                                                {
                                                    props => (
                                                        <div>
                                                            {/* <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: 'right' }}>
                                                                <ExportCSVButton {...props.csvProps}><i className='fa fa-download'></i> Export </ExportCSVButton>
                                                            </div> */}
                                                            <div style={{ backgroundColor: '#fff', marginTop: '5px', textAlign: "right" }}>
                                                                <button className='btn react-bs-table-csv-btn' onClick={DownloadSummaryData}><i className='fa fa-download'></i> Export
                                                                </button>
                                                            </div>
                                                            <BootstrapTable
                                                                classes='table table-striped table-hover table-width'
                                                                headerClasses='table-top'
                                                                bootstrap4
                                                                pagination={paginationFactory(options)}
                                                                {...props.baseProps}
                                                                filter={filterFactory()}
                                                            />
                                                            {/* <ExportCSVButton {...props.csvProps}><i className='fa fa-download'></i> Export</ExportCSVButton> */}
                                                        </div>
                                                    )
                                                }
                                            </ToolkitProvider> : <>
                                                <MycustomDesignGrid column={columns} />
                                            </>}
                                    </div>
                                </div>
                            </div>
                            <RightFilterToggle onSearchClick={searchOnClick} isFbNoDisabled="true" />
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </>
    )
}